import type { JSX } from 'react';
import moneyout from '@/enterprise/assets/moneyout.svg?url';
import percentagerotate from '@/enterprise/assets/percentagerotate.svg?url';
import stopwatch from '@/enterprise/assets/stopwatch.svg?url';

const BENEFITS = [
  {
    iconSrc: stopwatch,
    title: 'Fast decisions',
    description: 'Get a credit decision in as little as 3 minutes - no lengthy paperwork.',
  },
  {
    iconSrc: moneyout,
    title: 'Quick funding',
    description: 'If approved, funds can be deposited as soon as the next business day.',
  },
  {
    iconSrc: percentagerotate,
    title: 'Transparent pricing',
    description: 'Repay your principal plus a fixed fee - no ongoing interest.',
  },
];

const FundboxKeyBenefits = (): JSX.Element => (
  <div className="flex flex-col items-center space-y-8">
    <p className="text-3xl">Key Benefits</p>
    <div className="grid w-full grid-cols-1 gap-4 md:grid-cols-3">
      {BENEFITS.map((benefit) => (
        <div
          key={benefit.title}
          className="flex flex-col items-center space-y-3 rounded-2xl bg-white p-8 text-center shadow-md"
        >
          <img src={benefit.iconSrc} alt="" className="h-20 w-20" />
          <p className="text-lg font-medium">{benefit.title}</p>
          <p className="text-base text-text-secondary">{benefit.description}</p>
        </div>
      ))}
    </div>
  </div>
);

export default FundboxKeyBenefits;
